import styled, { keyframes, css } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const overlayBase = css`
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  z-index: 9999;
  animation: ${fadeIn} 0.2s ease;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  background: hsl(var(--hp-background, 230 25% 5%) / 0.72);
`;

export const Overlay = styled.div`
  ${overlayBase}
`;

export const OverlaySpinner = styled.span`
  width: 28px;
  height: 28px;
  border: 2px solid hsl(var(--hp-border, 230 15% 18%) / 0.8);
  border-top-color: hsl(var(--hp-primary, 32 95% 55%));
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

export const OverlayText = styled.p`
  margin: 0;
  font-family: Outfit, ui-sans-serif, system-ui, sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  color: hsl(var(--hp-muted-foreground, 230 10% 55%));
  letter-spacing: 0.02em;
`;
